import { render, staticRenderFns } from "./TasksSummaryBanner.vue?vue&type=template&id=23f755fa&"
import script from "./TasksSummaryBanner.vue?vue&type=script&lang=js&"
export * from "./TasksSummaryBanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports